import { SettingsToggleItem } from '@/components/molecules';
import { useTranslation } from '@/i18n';
import { useSettingsStore } from '@/stores/useSettingsStore';

export const UploadSettingsCard = () => {
  const { t } = useTranslation();
  const allowMobileDataUpload = useSettingsStore((state) => state.allowMobileDataUpload);
  const setAllowMobileDataUpload = useSettingsStore((state) => state.setAllowMobileDataUpload);
  const isLoading = useSettingsStore((state) => state.isLoading);

  return (
    <SettingsToggleItem
      title={t('settings.uploadSettings.allowMobileData')}
      value={allowMobileDataUpload}
      onValueChange={setAllowMobileDataUpload}
      disabled={isLoading}
    />
  );
};
